export const enum WebapiAcceptHeaders {
  MERCHANTS_V2 = 'application/vnd.budbee.merchants-v2+json',
  TERMINALS_V1 = 'application/vnd.budbee.terminals-v1+json',
  USERS_V2 = 'application/vnd.budbee.users-v2+json',
}
